/* User services */
import { request } from "../../Services/Api"

export const getUserInfo = (params) => request.api.get("/user/account/", params)

export const updateUserInfo = (data) => {
  const { user_id, ...info } = data || {}
  if (info.avatar) {
    const headers = { "Content-Type": "multipart/form-data" }
    const form = new FormData()
    form.append("avatar", info.avatar.media)
    return request.api.patch("/user/update/", form, { headers, params: { user_id } })
  }
  return request.api.patch("/user/update/", { ...info }, { params: { user_id } })
}

export const changePassword = ({ current, password }) =>
  request.api.put("/user/change_password/", { old_password: current, new_password: password })

export const sendCodePassword = (email) => {
  return request.api.post("auth/forgot-password/", { email })
}

export const confirmCodePassword = (code) =>
  request.api.get("auth/forgot-password/", { code, source: "settings" })

export const createNewPassword = ({ password, confirm_code }) => {
  return request.api.post("/user/set_password/", {
    new_password: password,
    confirm_code: confirm_code
  })
}

export const changeEmails = ({ password, new_email }) =>
  request.api.post("/user/change-email/", { new_email: new_email, password: password })

export const verifyEmail = ({ password, new_email }) =>
  request.api.post("/user/confirm-email/", { new_email: new_email, password: password })

export const confirmEmails = ({ hash, isVerify }) =>
  request.api.get(`/user/${isVerify ? "confirm" : "change"}-email/?code=${hash}`)

export const changeLanguage = (language) => request.api.post("/user/set-language/", { language })

export const sendOnboardingForm = (data) => request.api.post(`/user/media_source/`, data)

export const createBusinessAccount = (data) => {
  const headers = { "Content-Type": "multipart/form-data" }
  const form = new FormData()
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      value.forEach((newValue) => form.append(key, newValue))
    } else {
      let finalValue = key === "photo" ? value || "" : value
      form.append(key, finalValue)
    }
  }
  return request.api.post("/user/business-account/", form, { headers })
}

export const updateBusinessAccount = ({ id, business_account_settings, ...data }) => {
  if (data.photo || data.photo === null) {
    const headers = { "Content-Type": "multipart/form-data" }
    const form = new FormData()
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value)) {
        value.forEach((newValue) => form.append(key, newValue))
      } else {
        let finalValue = key === "photo" ? value || "" : value
        form.append(key, finalValue)
      }
    }
    return request.api.patch(`/user/business-account/${id}/`, form, { headers })
  }
  if (business_account_settings) {
    return request.api.patch(`/user/business-account-settings/${id}/`, { ...data })
  }
  return request.api.patch(`/user/business-account/${id}/`, { ...data })
}

export const getBusinessAccountsWithRole = () =>
  request.api.get("/user/business-account/header_business_accounts/")

export const getBusinessAccounts = (params) =>
  request.api.get('/user/business-account/', params)

export const getBusinessAccount = (id) => request.api.get(`/user/business-account/${id}/`)

export const getAutoRefundLogs = (id) =>
  request.api.get(`/user/business-account-settings/${id}/auto-refund-logs/`)

export const getIntegrationLogs = () =>
  request.api.get(`/integrations/logs/`)

export const deleteBusinessAccount = (id) => request.api.delete(`/user/business-account/${id}/`)

export const skipPaymentConnect = (businessAccountId) =>
  request.api.patch(
    `/user/business-account/${businessAccountId}/skip_connection_payment_processor/`,
    {}
  )

export const getPaymentProcessors = ({ integrationsPage, ...data }) => {
  //return request.api.get(`/user/payment-processor/`, data)
  if (integrationsPage) {
    return request.api.get(`/user/integration/`, data)
  } else {
    return request.api.get(`/user/payment-processor/`, data)
  }
}

export const getNextcommerceUrl = (store) => {
  return request.api.get(`/nextcommerce/install/?store=${store}`)
}

export const connectPaymentProcessor = ({ service_name, ...data }) => {
  if (service_name === "manual_refunds") {
    return request.api.post(`/user/payment-processor/connect-${service_name}/`, data)
  } else if (service_name === "authorize.net") {
    return request.api.post(`/integrations/authorize/`, data)
  } else if (["nmi", "airwallex", "adyen"].includes(service_name)) {
    return request.api.post(`/integrations/${service_name}/`, data)
  } else if (service_name === "next") {
    return request.api.post(`/user/nextcommerce/`, data)
  } else {
    return request.api.post(`/user/${service_name}/`, data)
  }
}

export const disconnectPaymentProcessor = ({ service_name, payment_processor_id, ...params }) => {
  if (service_name === "manual_refunds") {
    return request.api.delete(
      `/user/payment-processor/${payment_processor_id}/disconnect-${service_name}/`
    )
  } else if (service_name === "authorize.net") {
    return request.api.delete(`/integrations/authorize/disconnect/`, {
      payment_processor_id,
      ...params
    })
  } else if (["nmi", "airwallex", "adyen"].includes(service_name)) {
    return request.api.delete(`/integrations/${service_name}/disconnect/`, {
      payment_processor_id,
      ...params
    })
  } else if (service_name === "next") {
    return request.api.delete(`/user/nextcommerce/`, { payment_processor_id, ...params })
  } else if (service_name === "maverick") {
    return request.api.delete(`/integrations/maverick/disconnect/`, {
      payment_processor_id,
      ...params
    })
  } else {
    return request.api.delete(`/user/${service_name}/disconnect/`, {
      payment_processor_id,
      ...params
    })
  }
}

export const adyenUploadFiles = ({ files, merchant_id }) => {
  const formData = new FormData()
  files.forEach((file) => {
    formData.append("files", file)
  })
  formData.append("merchant_id", merchant_id)

  return request.api.post("/integrations/adyen/upload-transactions/", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export const getNextcommerceDisconnectUrl = (business_account_id) => {
  return request.api.post(`/nextcommerce/disconnect-app/?merchant_id=${business_account_id}`)
}

export const createBillingDescriptor = (data) => {
  if (data.forEnrollment) {
    if (data.isAdmin) {
      const { isAdmin, ba_id, ...otherData } = data
      return request.api.patch(
        `/user/billing-descriptor/${ba_id}/update_billing_descriptors_for_user/`,
        otherData.descriptorList
      )
    } else {
      return request.api.post(
        "/user/billing-descriptor/create_billing_descriptor_for_enrollment/",
        data.descriptorList
      )
    }
  } else {
    return request.api.post("/user/billing-descriptor/", data)
  }
}

export const getBillingDescriptors = (data) => request.api.get("/user/billing-descriptor/", data)

export const getDescriptorsArnCodesSuggestions = () =>
  request.api.get("/user/billing-descriptor/get-descriptors-arn-codes/")

export const getUsersCards = (params) => request.api.get("/payments/cards/", params)

export const updateDefaultCard = ({ card_id, data, user_id }) =>
  request.api.patch(`/payments/cards/${card_id}/`, data, { params: { user_id } })

export const deleteCard = ({ card_id, user_id }) => {
  if (user_id) {
    return request.api.delete(`/payments/cards/${card_id}/?user_id=${user_id}`)
  } else {
    return request.api.delete(`/payments/cards/${card_id}/`)
  }
}

export const updateBillingDescriptorStatus = (data) => {
  if (data?.descriptor_type) {
    return request.api.patch("/user/billing-descriptor/update-descriptor-type/", data)
  } else {
    return request.api.patch("/user/billing-descriptor/update_billing_descriptor_status/", data)
  }
}

export const createCheckoutSession = (payment_service_business_account_id, return_url) => {
  return request.api.post("/payments/create-checkout-session/", {
    payment_service_business_account_id,
    return_url: process.env.REACT_APP_BASE_URI + return_url
  })
}

export const attachPayment = ({
  checkout_session_id,
  new_business_account_to_attach,
  existing_card_id
}) => {
  if (checkout_session_id) {
    return request.api.post("/payments/attach-payment-method/", { checkout_session_id })
  } else {
    return request.api.post(
      `/user/business-account/${new_business_account_to_attach}/attach-saved-payment-method/`,
      { existing_card_id }
    )
  }
}

export const getPremiumFeatures = (params) => request.api.get("/shopify/connect/", params)

export const getEnrollments = (business_account_id) =>
  request.api.get("/user/enrollments/", { business_account_id })

export const getAdminEnrollments = ({ business_account_id, ...params }) =>
  request.api.get('/admin_panel/enrollments/', { business_account_id, ...params })

export const updateEnrollment = ({ id, ...data }) =>
  request.api.patch(`/user/enrollments/${id}/`, { ...data })

export const changeStatusEnrollment = ({ id, action }) =>
  request.api.patch(`/user/enrollments/${id}/${action}/`)

export const getEnrollmentsWithoutDescriptors = (business_account_id) =>
  request.api.get("/user/enrollments/without-billing-descriptors/", { business_account_id })

export const getDescriptorsByEnrollment = ({ enrollment_id, ...params }) =>
  request.api.get(`/user/enrollments/${enrollment_id}/billing-descriptors/`, params)

export const getAvailableBillingDescriptorStatuses = (enrollment_id) =>
  request.api.get(`/user/enrollments/${enrollment_id}/billing-descriptors/available-statuses/`)

export const getVisaCodesByEnrollment = ({ isAdmin, ...params }) =>
  isAdmin
    ? request.api.get("/admin_panel/visa-codes/", params)
    : request.api.get("/user/visa-codes/", params)
export const getAdminDescriptorsByEnrollment = ({ enrollment_id, ...params }) =>
  request.api.get(`/admin_panel/enrollments/${enrollment_id}/billing-descriptors/`, params)

export const updateAdminDescriptorStatus = ({ id, ...data }) =>
  request.api.patch(`/admin_panel/billing-descriptors/${id}/update-status/`, data)

export const updateAdminDescriptorType = ({ id, ...data }) =>
  request.api.patch(`/admin_panel/billing-descriptors/${id}/update-type/`, data)

export const requestNewIntegration = (data) =>
  request.api.post("/admin_panel/new_integration/", { ...data })

export const getMcpConnections = () => request.api.get("auth/mcp/connections/")

export const disconnectMcp = (key) => request.api.post("auth/mcp/connections/disconnect/", { key })

export const declinePremiumFeatures = () =>
  request.api.post("/shopify/connect/decline_prem_for_current_month/")
export const updateCompletedStep = ({ business_account_id, step }) =>
  request.api.get(
    `/user/business-account/${business_account_id}/update_completed_step/?completed_step=${step}`
  )
export const updateUserPrice = ({ ba_id, ...data }) =>
  request.api.patch(`/user/business-account/${ba_id}/update_pricing/`, { ...data })

export const getMaxCreateSteps = () => request.api.get("/user/onboarding-steps/")
export const finalizeOnboarding = () => request.api.post("/payments/finalize-onboarding/")

export const getBannerInfo = () => request.api.get("/dashboard/charts/banner_info/")

export const getBusinessInfo = ({ business_account_id }) =>
  request.api.get(`/user/business-account/${business_account_id}/business-info/`)

export const trackEvent = (data) => request.api.post("/user/track-event/", data)
export const getUserInfoByAdmin = (params) => request.api.get("/user/account/", params)

export const changeEmailOnboarding = ({ new_email }) =>
  request.api.post("/user/onboarding/change-email/", { new_email: new_email })

export const getCountries = () => request.api.get("/user/countries/")

export const validateBillingDescriptor = (body) =>
  request.api.post("/user/validate-billing-descriptor/", body)
export const checkMaverickDba = ({ merchant_id, dba_id }) => {
  return request.api.post("/integrations/maverick/check-dba/", {
    merchant_id,
    dba_id
  })
}

export const connectMaverickTerminals = ({ merchant_id, dba_id, terminal_ids }) => {
  return request.api.post("/integrations/maverick/connect-terminals/", {
    merchant_id,
    dba_id,
    terminal_ids
  })
}

export const updateDemoDataVisibility = ({ is_show_demo_data }) => {
  return request.api.patch(`/user/demo-data/`, { is_show_demo_data })
}
